import { render, staticRenderFns } from "./BaseCategoria.vue?vue&type=template&id=42d61e69&scoped=true&"
import script from "./BaseCategoria.vue?vue&type=script&lang=js&"
export * from "./BaseCategoria.vue?vue&type=script&lang=js&"
import style0 from "./BaseCategoria.vue?vue&type=style&index=0&id=42d61e69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d61e69",
  null
  
)

export default component.exports